
import { defineComponent, PropType } from 'vue'
import { NewsItem } from '@/types/News'

export default defineComponent({
  name: 'NewsList',

  props: {
    news: {
      type: Array as PropType<NewsItem[]>
    },
    isHome: {
      type: Boolean,
      default: false
    }
  }
})
